import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerCard.css';
import '../../../css/CustomerContractData.css';
import CustomerContractDetails from './CustomerContractDetails';
import LossReport from '../ContractCard/LossReport';
import ContractCancel from '../../ContractCancel';

import { PagingTable } from 'component-lib';
import { DateTimeHelper,RoleConfiguration } from 'utils-lib';
import { RequestAjaxClass, ContractsModel,PaymentsModel } from 'models-lib';

var moment = require('moment');
moment().format();
class CustomerContractData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.CustomerId = this.props.id;
        this.state.Start = 0;
        this.state.Limit = 10;
        this.state.StatusId = 1;
        this.GetRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.ContractsModel = new ContractsModel([this],null,this.GetRequest);
        this.PaymentsModel = new PaymentsModel([this], null, this.Request);
    }

    componentWillMount(){
        
        this.GetRequest.setApiUrl(Vas.ApiUrl);
        this.GetRequest.setApiKey(Vas.ApiKey);
        this.GetRequest.setAuth(true);
        this.GetRequest.setErrorHandler(()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });

        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });
        
    }

    LoadContractDetails(id)
    {
        ReactDOM.unmountComponentAtNode(document.getElementById('contractDetails'));
        ReactDOM.render(<CustomerContractDetails 
          Id={id} 
          table={this.refs.table} 
          reference={this} />
            , document.getElementById('contractDetails'));
    }

    Update(observer)
    {
        let me = this;
        this.setState({},()=>{
            if(observer === "Contracts"){
                let contracts = [];
                if (this.ContractsModel.Contracts)
                {         
                    this.ContractsModel.Contracts.forEach(function(value) {
                        let contract = {};
                        contract.Id = value.Id;
                        contract.ContractNumber = value.ContractNumber;
                        contract.TicketName = value.TicketName;
                        
                        let from = "";
                        let to = "";
                        if (value.DateFrom !== null && value.DateFrom !== "")
                        {
                            let cur = DateTimeHelper.StringToDate(value.DateFrom, true,localStorage.getItem('vas_language'));
                            if (cur.isSame(moment(['0001','00','01']))=== true){
                                from =  Vas.Resources.Labels["Unlimited"];
                            } else {
                                from = DateTimeHelper.FormatToShortDateString(cur);
                            }
                        }
                        if (value.DateTo !== null && value.DateTo !== "")
                        {
                            let cur = DateTimeHelper.StringToDate(value.DateTo, true,localStorage.getItem('vas_language'));
                            if (cur.isSame(moment(['0001','00','01']))=== true){
                                to = Vas.Resources.Labels["Unlimited"];
                            } else {
                                to = DateTimeHelper.FormatToShortDateString(cur);
                            }
                        }
                        contract.DateFrom=from;
                        contract.DateTo=to;
                        if (value.StatusId === 10){
                            contract.Status=Vas.Resources.Labels["PendingApproval"];
                        } else {
                            contract.Status=value.Status; 
                        }
                        
                        contract.StatusId = value.StatusId;
                        contracts.push(contract);
                    });
                }
                me.setState({ Contract:contracts });
                if (me.refs.table){
                    me.refs.table.setState({ Data: contracts, Count: this.ContractsModel.Count, Limit: this.ContractsModel.Limit, Start: this.ContractsModel.Start, End: this.ContractsModel.Start+contracts.length });
                }
                $("#LoadingIcon").removeClass().addClass('hide');
            }
            else if(observer === "Payment"){
                if (me.PaymentsModel.Count !== null && me.PaymentsModel.Count !== undefined) {
                    let count = me.PaymentsModel.Count;
                    //let count = 0;
                    if (count > 0) {
                        let valid = false;
                        for (let i = 0; i< count; i++){
                            if (me.PaymentsModel.Payments[i].PaymentMethodValue === 4){
                                valid = true;
                                break;
                            }
                        }
                        if (valid === true){
                            Vas.GetView('CreateContract', { CustomerId:me.CustomerId }, true);
                        } else {
                            Vas.GetView('NoPayment',{ CustomerId:me.CustomerId },true);
                        }
                    } else {
                        Vas.GetView('NoPayment',{ CustomerId:me.CustomerId },true);
                    }
                }
            }
        });
    }

    load(sendData){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.ContractsModel.GetContractsByCustomerId(this.CustomerId,sendData,this.state.Start,this.state.Limit,null,null,null);
    }

    AddContract(){
        this.PaymentsModel.GetPaymentsByCustomerId(this.CustomerId);
    }

    loadContract(id){
        let me = this;
        let contracts=me.refs.table.state.Data;
        let contract=[];
        for (let i=0;i<contracts.length;i++){
            if (contracts[i].Id === id){
                contract.push(contracts[i]);
            }
        }
        me.LoadContractDetails(id);
    }

    render()
    {   
        let rights = RoleConfiguration.getRoleConfig();
        let role = localStorage.getItem("vas_role");
        
        let right = '';
        if (role === "1"){
            if (rights[1]){
                right =  rights[3];
            }
        }
        if (role === "3" || role === "99"){
            if (rights[0]){
                right = rights[2];
            }
        }

        $("#Content").css("opacity", "0.4");
       return (<div ><table >
         <thead>
         </thead>
         <tbody>
           <tr>
             <td>
               <PagingTable 
               ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                 ref="table" 
                 TableReference={this} 
                 DataBaseTable={"B2Vertraege"} 
                 SearchParams={[{ Parameter: 'StatusId', SearchValue: 1 }]} 
                 Selectable={false} 
                 Limit={this.state.Limit} 
                 Start={this.state.Start} 
                 End={this.state.End} 
                 Count={this.state.Count} 
                 Columns={[Vas.Resources.Labels["ContractNumber"],Vas.Resources.Labels["Product"],Vas.Resources.Labels["Begin"],
                                Vas.Resources.Labels["End"],Vas.Resources.Labels["State"]]}
                 Keys={["ContractNumber","TicketName","DateFrom","DateTo","Status"]} 
                 Data={this.state.Data}  
                 CSV={true} 
                 CSVTableName={this.props.Name + '_' + Vas.Resources.Labels["Contracts"]}
                 CSVController={"/Customers/" + this.CustomerId + "/Contracts"}
                 Token={localStorage.getItem('vas_token')}
                 AppURL={Vas.ApplicationUrl} 
                 ApiURL={Vas.ApiUrl} 
                 ApiKey={Vas.ApiKey}
                 Border={false} 
                 Add={true} 
                 AddClick={()=>{this.AddContract();}}
                 Right={right}
                 LabelPage={Vas.Resources.Labels["Page"]} 
                 LabelOf={Vas.Resources.Labels["Of"]} 
                 LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                 Filter={true} 
                 FilterData={[{ Key:"-1", Display:Vas.Resources.Labels["All"] },
                                { Key:"1", Display:Vas.Resources.Labels["Active"] },
                                { Key:"2", Display:Vas.Resources.Labels["Canceled"] },
                                { Key:"10", Display:Vas.Resources.Labels["PendingApproval"] },
                                { Key:"3",Display:Vas.Resources.Labels["Loss"] } ,
                                { Key:"5",Display:Vas.Resources.Labels["Changed"] },
                                { Key:"6",Display:Vas.Resources.Labels["Deleted"] },
                                { Key:"7",Display:Vas.Resources.Labels["Expired"] },
                                { Key:"15",Display:Vas.Resources.Labels["Declined"] }
                            ]} 
                 FilterColoumn={"StatusId"} 
                 FilterText={Vas.Resources.Labels["Filter"]} 
                 FilterDefault={Vas.Resources.Labels["Active"]} 
                 SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                 CWidth={[120,120,100,100,100]}
                 AddString={Vas.Resources.Labels["Add"]}
                 LossReport={false}
                 LossReportClick={(event)=>{
                    let id = $(event.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;
                     ReactDOM.render(<LossReport 
                       ContractId={id} 
                       me={this} 
                       table={this.refs.table} 
                       reference={this.props.reference} /> 
                        , document.getElementById('popupContainer'));}}
                 LossReportTooltip={Vas.Resources.Labels["LossReport"]}
                 ContractCancel={true}
                 ContractCancelClick={(event)=>{
                    let id = $(event.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;
                    ReactDOM.render(<ContractCancel 
                      ContractId={id} 
                      me={this} 
                      table={this.refs.table} 
                      reference={this} /> 
                                  , document.getElementById('popupContainer'));
                 }}
                 ContractCancelTooltip={Vas.Resources.Labels["ContractCancel"]}
                 NewApi={true}
                 RowOnClick={(id)=>{this.loadContract(id);}}
                 //onLoad={()=>{this.load();}}
                />
             </td>
           </tr>
            
         </tbody>
           
       </table><div 
         className={"contractDetails"} 
         id={"contractDetails"}>{Vas.Resources.Labels["NoContracts"]}
       </div></div>);
    }
}
export default CustomerContractData;
